<template>
  <div
    v-tooltipable
    class="overflow-hidden text-ellipsis whitespace-nowrap"
    :class="textClass"
  >
    <slot />
  </div>
</template>
<script setup lang="ts">
const { textClass } = defineProps<{
  textClass?: string;
}>();
</script>
